export const States = {
	Warning: 'warning',
	Info: 'info',
	Success: 'success',
} as const;
